// React
import { Fragment } from "react"

// Components
import { styles as stylePdf } from "components"

// Third-Party Libraries
import moment from "moment"
import { Document, Page, Text, View } from "@react-pdf/renderer"
import { jwtDecode } from "jwt-decode"

// Types
import type { LinkAccountType } from "../types"

// Utils
import { AccountListType } from "../utils"

export function PdfLinkAccountPos(props: {
    dataList: LinkAccountType[],
    dataLinkAccount: AccountListType[],
    title: string
}): JSX.Element {
    // Vars
    const date: string = moment().format("DD MMM YYYY")
    const userData: { company_name?: string } = jwtDecode(localStorage.getItem("token") ?? "")
    const { title } = props

    return (
        <Document>
            <Page size="A4" style={stylePdf.page}>
                <View
                    fixed
                    style={stylePdf.fixedTop}
                >
                    <Text style={stylePdf.title}>{title}</Text>
                    <Text style={stylePdf.date}>{userData.company_name}</Text>
                    <Text style={stylePdf.date}>Date: {date}</Text>
                </View>

                <TableCell
                    dataList={props.dataList}
                    dataLinkAccount={props.dataLinkAccount}
                />

                <View
                    fixed
                    style={stylePdf.fixed}
                >
                    <Text style={stylePdf.text}>{title} | {userData.company_name ?? "-"} | {date}</Text>

                    <Text
                        style={stylePdf.text}
                        render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                    />
                </View>
            </Page>
        </Document>
    )
}


function TableCell(props: {
    dataList: LinkAccountType[],
    dataLinkAccount: AccountListType[]
}): JSX.Element {
    const header = ["LOCATION","NUMBER","COA NAME"]

    return (
        <Fragment>
            {props.dataLinkAccount.map((i, key) => (
                <>
                    <View style={{ marginTop: 5 }}>
                        <Text style={[stylePdf.headerText, { fontSize: 10 }]}>{i.header}</Text>
                    </View>
                    <View style={stylePdf.table} key={key}>

                        {/* Header */}
                        <View style={stylePdf.tableHeader}>
                            {header.map((col, index) => (
                                <View style={stylePdf.tableCol}>
                                    <Text
                                        style={[
                                            stylePdf.headerText,
                                            { fontSize: 9 }
                                        ]}
                                        key={index}
                                    >
                                        {col}
                                    </Text>
                                </View>
                            ))}
                        </View>

                        {/* Data */}
                        {i.linkAccount.map((sub, index) => {
                            const coa = props.dataList.find((i) => i.location_id.toString() === sub.location_id && i.trx === sub.trx)
                            return (
                                <>
                                    <View style={stylePdf.tableRow} key={index}>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {sub.location_name}
                                            </Text>
                                        </View>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {coa ? `${coa.coa_code}` : ''}
                                            </Text>
                                        </View>
                                        <View style={stylePdf.tableCol}>
                                            <Text style={[stylePdf.tableCell, { fontSize: 8 }]}>
                                                {coa?.coa_name}
                                            </Text>
                                        </View>
                                    </View>
                                </>
                            )
                        })}
                    </View>
                </>
            ))}

        </Fragment>
    )
}